<template>
  <div>
    <h5 v-if="existContent" class="title mt-4 mb-4">
      Conteúdos complementares
    </h5>
    <a
      v-for="(file, index) in lesson.extra_files"
      :key="'f' + index"
      class="w-100 material d-flex mb-3"
      :class="{ 'material--loading': downloadingFiles[file.id] }"
      v-bind="isDrmProtected(file) ? {} : { href: file.file, target: '_blank' }"
      role="button"
      @click="handleExtraFileClick($event, file)"
    >
      <i :class="`mr-2 ${getIcon(file)}`"></i>
      <span class="flex-fill">
        {{ downloadingFiles[file.id] ? "Preparando download..." : file.name }}
      </span>
      <i v-if="downloadingFiles[file.id]" class="fa fa-spinner fa-spin"></i>
      <i v-else class="fa fa-arrow-up-right-from-square"></i>
    </a>

    <a
      v-for="(reading, index) in lesson.extra_reading"
      :key="'r' + index"
      :href="reading.link"
      target="_blank"
      class="w-100 material d-flex mb-3"
    >
      <i class="mr-3 fa fa-link ml-n2"></i>
      <span class="flex-fill">
        <strong>{{ reading.site_name }}</strong>
        : {{ reading.title }}
      </span>
      <i class="fa fa-arrow-up-right-from-square"></i>
    </a>
  </div>
</template>
<script>
import Vue from "vue";
import get from "lodash/get";

export default {
  props: ["lesson"],
  data() {
    return {
      downloadingFiles: {}
    };
  },
  computed: {
    existContent() {
      return (
        (this.lesson.extra_files && this.lesson.extra_files.length > 0) ||
        (this.lesson.extra_reading && this.lesson.extra_reading.length > 0)
      );
    }
  },
  methods: {
    isDrmProtected(file) {
      return file.enable_drm && file.ext === "pdf";
    },

    handleExtraFileClick(event, file) {
      if (!this.isDrmProtected(file)) return;

      event.preventDefault();
      if (this.downloadingFiles[file.id]) return;

      this.downloadWithDRM(file);
    },

    async downloadWithDRM(file) {
      if (!file.download_url) {
        window.open(file.file, "_blank");
        return;
      }

      Vue.set(this.downloadingFiles, file.id, true);
      try {
        const response = await window.axios.get(file.download_url, {
          responseType: "blob"
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${file.name}.${file.ext}`;
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 1000);
      } catch {
        window.open(file.file, "_blank");
      } finally {
        Vue.set(this.downloadingFiles, file.id, false);
      }
    },

    getIcon(file) {
      const extension = get(file, "file", ".*")
        .split(".")
        .pop();
      const MAP = {
        pdf: "icon-book ml-n2",
        txt: "icon-book ml-n2",
        doc: "icon-book ml-n2",
        mp3: "icon-song",
        ogg: "icon-song",
        mp4: "icon-play",
        mov: "icon-play",
        flv: "icon-play",
        png: "icon-image mr-3",
        jpg: "icon-image mr-3",
        webp: "icon-image mr-3",
        "*": "icon-link"
      };
      return MAP[extension];
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  line-height: 34px;
}
.title {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.material {
  border-radius: 8px;
  padding: 19px 20px;
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration: none;
  border: 1px solid transparent;

  .fa.fa-link,
  .fa.fa-arrow-up-right-from-square {
    font-size: 16px !important;
  }

  i {
    font-size: 24px !important;
  }

  &:hover {
    border: 1px solid var(--verso-light-roxo, #3e56ac);
  }

  &--loading {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>
